import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: { main: '#0075FF' },
        secondary: { main: '#00B2FF' },
        background: { default: '#ffffff', paper: '#ffffff' }
    },
    shape: { borderRadius: 2 },
    typography: {
        fontFamily: 'Poppins, sans-serif',
        h1: { fontWeight: 700, color: '#1f2937' },
        h2: { fontWeight: 700, color: '#1f2937' },
        h3: { fontWeight: 700, color: '#1f2937' },
        h4: { fontWeight: 700, color: '#1f2937' },
        button: { textTransform: 'none', fontWeight: 600 }
    },
    components: {
        MuiAppBar: { defaultProps: { elevation: 0 } },
        MuiButton: {
            defaultProps: { disableElevation: true },
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    textTransform: 'none'
                },
                containedPrimary: {
                    backgroundColor: '#0075FF',
                    '&:hover': { backgroundColor: '#0056CC' }
                }
            }
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 8
                }
            }
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    minHeight: 30,
                    '&.Mui-selected': { fontWeight: 700 }
                }
            }
        },
        MuiLink: {
            styleOverrides: {
                root: {
                    textDecoration: 'none',
                    '&:hover': { color: '#0075FF' }
                }
            }
        }
    }
});

export default theme;
